
import apiBase from "./api-base";

export default class User extends apiBase {
    constructor(store) {
        const path = "v1/User";
        super(store, path);
    }

    GeneratePINforClientsInRestaurant(model, showProgress) {
        return this._request({
            action: "GeneratePINforClientsInRestaurant",
            method: "post",
            body: model,
            showProgress,
        });
    }
    SwitchUser(model, showProgress) {
        return this._request({
            action: "SwitchUser",
            method: "post",
            body: model,
            showProgress,
        });
    }
    



}